import { AppHelper } from "../appHelper"
import { Grid } from "../core/components/grid";
import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Button } from "../core/components/button";
import { IsPanelbarDetails } from "../core/components/isPanelbarDetails";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsSearchField } from "../core/components/isSearchField";
import EditFlexTime from "./editFlexTime";
import { NotificationHelper } from "../core/util/notificationHelper";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";


interface FlexTimeAppState {
    selectedListGridDate: string,
    ressNr: string,
    monthOffset: number,
    pwZusatzRecht: number,
    monthCanBeClosed: boolean,
    monthEnd: string
}

export class FlexTimeApp extends React.Component<FlexTimeProps, FlexTimeAppState> {
    common = new AppHelper();

    translations: StringKeyDictionary<string>;

    flexTimeListGridData: Array<any> = [];
    flexTimeListGridRef: Grid;
    flexTimeListGridOptions: kendo.ui.GridOptions;


    flexTimeDetailsGridData: Array<any> = [];
    flexTimeDetailsGridRef: Grid;
    flexTimeDetailsGridOptions: kendo.ui.GridOptions;

    flexNachschlagData = {};

    private _editMetaData: {} = null;


    resetSelectionListGrid: boolean = false;



    constructor(props) {
        super(props);

        this.state = {
            selectedListGridDate: null,
            ressNr: this.props.entity.RessNr,
            monthOffset: this.props.entity.MonthOffset,
            pwZusatzRecht: null,
            monthCanBeClosed: null,
            monthEnd: null
        }

        this.common.init(this);
        this.reloadListData(this.props.entity.RessNr, this.props.entity.MonthOffset, null);
    }


    reloadListData = (ressNr: string, monthOffset: number, datum: string, refresh: boolean = false) => {
        HTTPService.get("FlexTime/GetFlexTimeData?ressNr=" + encodeURIComponent(ressNr == null ? "" : ressNr) + "&monthOffset=" + encodeURIComponent(monthOffset))
            .then(result => {
                Helper.setArrayValues(this.flexTimeListGridData, result.Data.FlexTimeListMonthViewModel);
                if (this.flexTimeListGridData.length > 0) {
                    this.flexTimeListGridData.forEach(item => {

                        const isDummy = (item["Von"] == "0" && item["Bis"] == "1") ||
                            (item["Von"] == "0" && item["Bis"] == "0" && item["Pause"] == "0" && item["Travel"] == "0");

                        if (isDummy) {
                            item["Von"] = "";
                            item["Bis"] = "";
                            item["Pause"] = "";
                            item["Travel"] = "";
                        } else {
                            item["Von"] = Helper.dates.getMinToHHMM(item["Von"]);
                            item["Bis"] = Helper.dates.getMinToHHMM(item["Bis"]);
                            item["Pause"] = Helper.dates.getMinToHHMM(item["Pause"]);
                            item["Travel"] = Helper.dates.getMinToHHMM(item["Travel"]);
                        }
                        item["ActualTimes"] = Helper.dates.getMinToHHMM(item["ActualTimes"]);
                        item["SystemTriggerTimes"] = Helper.dates.getMinToHHMM(item["SystemTriggerTimes"]);
                        item["CorrectionTimes"] = Helper.dates.getMinToHHMM(item["CorrectionTimes"]);
                        item["TargetTimes"] = Helper.dates.getMinToHHMM(item["TargetTimes"]);
                        item["SummaryTimes"] = Helper.dates.getMinToHHMM(item["SummaryTimes"]);
                    });

                    this.flexTimeListGridData[0]["Datum"] = "";
                    this.flexTimeListGridData[0]["Von"] = "";
                    this.flexTimeListGridData[0]["Bis"] = "";
                    this.flexTimeListGridData[0]["Pause"] = "";
                    this.flexTimeListGridData[0]["Comment"] = "";
                    this.flexTimeListGridData[0]["Travel"] = "";

                    this.flexTimeListGridData[0]["ActualTimes"] = "";
                    this.flexTimeListGridData[0]["SystemTriggerTimes"] = "";
                    this.flexTimeListGridData[0]["TargetTimes"] = "";
                    this.flexTimeListGridData[0]["CorrectionTimes"] = "";

                    this.flexTimeListGridData[0]["SummaryTimes"] = result.Data.SummaryPriorTimes;
                }

                this.props.entity.MonthStart = result.Data.MonthStart;
                this.props.entity.MonthEnd = result.Data.MonthEnd;


                this.props.entity.ActualTimes = result.Data.ActualTimes;
                this.props.entity.SystemTriggerTimes = result.Data.SystemTriggerTimes;
                this.props.entity.CorrectionTimes = result.Data.CorrectionTimes;
                this.props.entity.TargetTimes = result.Data.TargetTimes;
                this.props.entity.SummaryTimes = result.Data.SummaryTimes;
                this.props.entity.monthCanBeClosed = result.Data.monthCanBeClosed;
                this.props.entity.SummaryActualTimes = result.Data.SummaryActualTimes;
                this.props.entity.CapLimitRessource = result.Data.CapLimitRessource;
                this.props.entity.SummaryPriorTimes = result.Data.SummaryPriorTimes;
                this.props.entity.SummaryFlexTimeInclCurrent = result.Data.SummaryFlexTimeInclCurrent;


                this.setState({
                    ressNr: ressNr,
                    monthOffset: monthOffset,
                    selectedListGridDate: datum,
                    pwZusatzRecht: result.Data.PwZusatzRecht,
                    monthCanBeClosed: result.Data.monthCanBeClosed,
                    monthEnd: result.Data.MonthEnd
                });

                if (!Helper.hasValue(datum) && refresh) {
                    this.flexTimeDetailsGridData = [];
                    this.setState({ selectedListGridDate: null });
                } else
                    this.reloadDetails(ressNr, datum, refresh);
            });
    }

    private reloadDetails = (ressNr: string, datum: string, refresh: boolean = false) => {
        return createHtppServiceInstance().noBusyIndicator().get("FlexTime/GetFlexTimeDetails?ressNr=" + encodeURIComponent(ressNr == null ? "" : ressNr)
            + "&Datum=" + encodeURIComponent(datum == null ? "" : datum))
            .then(result => {
                Helper.setArrayValues(this.flexTimeDetailsGridData, result);

                this.flexTimeDetailsGridData.forEach(item => {
                    item["Minuten"] = Helper.dates.getMinToHHMM(item["Minuten"]);
                });

                if (refresh)
                    this.setState({});
            });
    }


    private _flexTimeListGridSelectionChanged = (dataItem) => {
        if (!this.resetSelectionListGrid) {
            const date = Helper.hasValue(dataItem) ? dataItem.Datum : null;

            if (date == null) {
                if (this.flexTimeDetailsGridData.length > 0) {
                    this.flexTimeDetailsGridData = [];
                    this.setState({ selectedListGridDate: date });
                }
            } else {
                this.reloadDetails(this.state.ressNr, date).then(() => {
                    this.setState({ selectedListGridDate: date });
                });
            }
        }
        else
            this.resetSelectionListGrid = false;
    }


    public canEdit = (): boolean => {
        return Helper.hasValue(this.state.pwZusatzRecht) && Helper.hasValue(this.state.monthCanBeClosed) &&
            ((this.state.pwZusatzRecht == 2 && this.state.monthCanBeClosed) ||
                (this.state.pwZusatzRecht == 3));
    }

    public canShow = (): boolean => {
        return Helper.hasValue(this.state.pwZusatzRecht) && this.state.pwZusatzRecht > 0;
    }

    public hasRessNr = (): boolean => {
        return Helper.hasValue(this.state.ressNr) && this.state.ressNr != "";
    }


    renderFlexTimeRessDisplay = () => {
        let issfProps = ComponentHelper.createFactory().getDefaultSearchFieldProps();
        issfProps.value = this.state.ressNr;
        issfProps.field.readOnly = true;
        issfProps.field.newButtonEnabled = false;

        //issfProps.disabled = !this.weeklyReportList.RecordRight.ZentralerUser; // Nur zentrale User dürfen die Ressource wechseln
        issfProps.field.readOnlyTextField = true;
        issfProps.field.searchWindowTitle = this.translations["WebSMS.FlexTime.Ressourcensuche"];
        issfProps.field.searchWindowUrl = "DynamicSearch/Window/Resource_FlexTime";
        issfProps.onChange = (field, value, dataItem) => {
            this.reloadListData(value, this.state.monthOffset, null);
        };

        let ispdProps = ComponentHelper.createFactory().getDefaultPanelbarDetailsProps();
        ispdProps.field.url = "ResourceLookup/ResourceHeader";
        ispdProps.field.template = "ResourceDetails";
        ispdProps.handleEval = this.common.evalAction;
        ispdProps.value = this.state.ressNr;

        return (
            <div className="flex-container">
                <div className="flex-container flex-container--row flex-container--align-center" style={{ height: "auto", marginTop: 10, marginBottom: 10 }}>
                    <label style={{ marginRight: 20 }}>{this.translations["WebSMS.FlexTime.Ressnr"]}</label>
                    <div style={{ width: 200 }}><IsSearchField {...issfProps} /></div>
                </div>
                <div style={{ width: 360 }}>
                    <IsPanelbarDetails {...ispdProps} />
                </div>
            </div>);
    }

    renderFlexTimeListGrid = () => {
        return (
            <div className="flex-container__item" >
                <Grid
                    data={this.flexTimeListGridData}
                    options={this.flexTimeListGridOptions}
                    id="flexTimeListGrid"
                    onSelectionChanged={this._flexTimeListGridSelectionChanged}
                    ref={(r) => this.flexTimeListGridRef = r}
                    selectFilter={this.state.selectedListGridDate != null ? this.state.selectedListGridDate : null}
                    selectFilterField="Datum" />
            </div>
        );
    }

    renderFlexTimeDetailsGrid = () => {
        return (
            <div className="flex-container__item" >
                <Grid
                    data={this.flexTimeDetailsGridData}
                    options={this.flexTimeDetailsGridOptions}
                    id="flexTimeDetailsGrid"
                    ref={(r) => this.flexTimeDetailsGridRef = r}
                />
            </div>
        );
    }


    handleClickLeft = () => {
        const mo = this.state.monthOffset - 1;
        this.reloadListData(this.state.ressNr, mo, null);
    }

    handleClickRight = () => {
        const mo = this.state.monthOffset + 1;
        this.reloadListData(this.state.ressNr, mo, null);
    }

    refreschGrids = () => {
        this.reloadListData(this.state.ressNr, this.state.monthOffset, null);
    }

    renderButtons = () => {
        return (
            <div className="flex-container flex-container--row flex-container--align-center">
                <Button handleClick={this.handleClickLeft} buttonStyle={{ marginLeft: 20 }} iconName={"arrow-alt-left"} readOnly={!this.hasRessNr()} />
                <Button handleClick={this.handleClickRight} buttonStyle={{ marginLeft: 5 }} iconName={"arrow-alt-right"} readOnly={this.state.monthOffset >= 0 || !this.hasRessNr()} />
            </div>);
    }

    private _initEditWindow(datum: string) {

        //const datum = dataItem? dataItem.Datum: Helper.dates.getISODateString(this.props.entity.MonthEnd);

        if (!Helper.hasValue(datum))
            datum = this.state.monthEnd;

        let d = new Date();
        d.setHours(0, 0, 0, 0);


        const recordRignts = {
            CanWrite: true,
            CanRead: true
        };

        const entity = {
            IsNew: true,
            RecordRight: recordRignts,
            RessNr: this.state.ressNr,
            Datum: datum,
            BuchungsDatum: null,
            Minuten: 10,
            MonthEnd: this.props.entity.MonthEnd,
            MonthStart: this.props.entity.MonthStart,
            Bemerkung: ""
        }

        const props = { dataSources: {}, metadata: this._editMetaData as Metadata, entity: entity, isWindow: true, context: { contextType: "editFlexTime" } as Context };

        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.reloadListData(this.state.ressNr, this.state.monthOffset, target.entity.Datum, true);
        });

        sheet.show(() => {
            sheet.mountContent(EditFlexTime, props);
        });
    }

    public addManualCorrection = () => {
        if (Helper.hasValue(this._editMetaData)) {
            this._initEditWindow(this.state.selectedListGridDate);
        } else {
            Helper.getMetaData("editFlexTime")
                .then((result) => {
                    this._editMetaData = result;
                    this._initEditWindow(this.state.selectedListGridDate);
                });
        }
    }


    public canCloseMonth = (): boolean => {
        return this.canEdit() && this.state.monthOffset == -1;
    }

    public closeMonth = () => {

        const ressNr = this.state.ressNr;

        HTTPService.post<JsonResultClass>("FlexTime/CloseMonth?ressNr=" + encodeURIComponent(ressNr))
            .then((result) => {
                if (result.Code == 0) {
                    this.props.entity.IsNew = false;

                    this.setState({}, () => {
                        this.reloadListData(this.state.ressNr, this.state.monthOffset, this.state.selectedListGridDate, true);
                    });
                    NotificationHelper.showSuccessMessage(this.translations["WebSMS.FlexTime.CloseMonthOk"]);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }

                //if (result.Code == 0)
                //    this.common.sheetWrapper.hide();

            });
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};

export interface FlexTimeProps extends AppBaseProps {
    entity: FlexTimeEntity;
    context: FlexTimePropsContext;
}

interface FlexTimePropsContext extends Context {
}

export interface FlexTimeEntity extends Entity {
    MonthOffset: number;
    MonthEnd: string;
    MonthStart: string;
    RessNr: string;
    FlexTimeListMonthViewModel: any;
    ActualTimes: number;
    SystemTriggerTimes: number;
    CorrectionTimes: number;
    TargetTimes: number;
    SummaryTimes: number;
    monthCanBeClosed: Boolean;
    PwZusatzRecht: number;
    CapLimitRessource: number;
    SummaryActualTimes: number;
    SummaryPriorTimes: number;
    SummaryFlexTimeInclCurrent: number;
}